<lib-input-base
  label="{{ '#HARDWARE_MANAGEMENT.FORM.KTOSTAMM_STANDORT.LABEL' | translate }}"
  controlName="ktostamm_standort"
  [required]="required"
  (valueChange)="valueChanged($event)"
  (select)="select($event); inputBase.isOpen$.next(false)"
  [entities]="(standorte$ | async) ?? []"
  [formGroup]="formGroup"
  [readonly]="readonly"
  [entityResultTemplate]="resultTemplate"
  [selectedTemplate]="selectedTemplate"
  [filter]="filterTypes"
  #inputBase>
</lib-input-base>

<ng-template #selectedTemplate let-entity>
  {{ entity?.subnummer }} - {{ entity.kurzbez }}
</ng-template>

<ng-template #resultTemplate let-entity>
  <div class="grid" style="grid-template-columns: auto 2.5rem">
    <div class="!flex w-full flex-col justify-center border-solid py-2 pr-4 text-ellipsis overflow-hidden" (click)="select(entity); inputBase.isOpen$.next(false)">
      <strong [title]="$safeNavigationMigration(entity?.typ)" class="text-ellipsis overflow-hidden">{{ entity.subnummer }} - {{ entity['11'] }}</strong>
      <div class="text-sm opacity-75 text-ellipsis overflow-hidden">{{ entity['3'] }}</div>
    </div>
  </div>
</ng-template>

